import React, { useEffect, useState } from "react";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import INotification from "../../../../models/INotification";
import IUserUI from "../../../../models/IUserUI";
import IPurchase_Order from "../../../../models/IPurchase_Order";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import { Document, Page, pdfjs } from "react-pdf";
import IQBOGetPdfPurchaseOrderDTO from "../../../../models/DTO/IQBOGetPdfPurchaseOrderDTO";
import { Socket } from "socket.io-client";
import IQBODeletePurchaseOrderDTO from "../../../../models/DTO/IQBODeletePurchaseOrderDTO";
import IQBOOnDeletePurchaseOrderDTO from "../../../../models/DTO/IQBOOnDeletePurchaseOrderDTO";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    purchaseOrder: IPurchase_Order;
};

export const QboViewPurchaseOrderSidebar: React.FC<Props> = (props) => {
    const [file, setFile] = useState<any>();

    const getPdfEstimate = () => {
        const payload: IQBOGetPdfPurchaseOrderDTO = {
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            qbo_PurchaseOrderId: props.purchaseOrder.qbo_PurchaseOrderId!,
        };

        props.socket.emit(EndpointsEnum.QBOGetPDFPurchaseOrder, payload);
    };

    const onGetPdfPurchaseOrder = (data: any) => {
        setFile(data);
    };

    const deletePurchaseOrder = () => {
        const payload: IQBODeletePurchaseOrderDTO = {
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            qbo_PurchaseOrderId: props.purchaseOrder.qbo_PurchaseOrderId!,
        };

        props.socket.emit(EndpointsEnum.QBODeletePurchaseOrder, payload);
    };

    const onDeletedPurchaseOrder = (data: IQBOOnDeletePurchaseOrderDTO) => {
        const notification: INotification = {
            message: "delete_purchase_order",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        props.notifyFn(null, notification);

        props.cancelFn(true);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.QBOOnGetPDFPurchaseOrder, fn: onGetPdfPurchaseOrder },
        { endpoint: EndpointsEnum.QBOOnDeletePurchaseOrder, fn: onDeletedPurchaseOrder },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            props.socket.on(_socket.endpoint, _socket.fn);
        }

        getPdfEstimate();

        return () => {
            for (const _socket of sockets) {
                props.socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const downloadPdfPurchaseOrder = () => {
        if (file) {
            const blob = new Blob([file], { type: "application/pdf" }); // change resultByte to bytes

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            const fileName = props.purchaseOrder.name;

            link.download = `Purchase Order ${fileName}.pdf`;
            link.click();
        }
    };

    return (
        <div className={"QboViewPurchaseOrderSidebar p-2"}>
            <div className="header">
                <div className="text-end">
                    <OwButton
                        centerIconClass={"far fa-times"}
                        className={"btn-danger"}
                        fn={() => {
                            props.cancelFn();
                        }}
                    />
                </div>
                <div className="mt-2 mb-2">
                    <OwButton
                        className={"btn-sm btn-primary me-2"}
                        fn={downloadPdfPurchaseOrder}
                        leftIconClass={"fas fa-download"}
                        title={"download"}
                    />
                    <OwButton
                        className={"btn-sm btn-danger"}
                        fn={deletePurchaseOrder}
                        leftIconClass={"fas fa-trash-alt"}
                        title={"delete"}
                    />
                </div>
            </div>
            <div style={{ height: "90vh", overflow: "scroll" }}>
                <Document className="vh-90" renderMode="canvas" file={file}>
                    <Page pageIndex={0} />
                </Document>
            </div>
        </div>
    );
};
